/*!
 * vue-router-parameters-controller v0.10.14 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
import { pick, omit } from 'ramda';
import { renderSlim } from '@aspectus/vue-utils';
import { Tag } from '@aspectus/vue-tag';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var same = function same(x) {
  return x;
};

var pathOmitter = omit(['path']);
var routerPicker = pick(['query', 'path', 'params', 'name']);

var routerOmitter = function routerOmitter(value) {
  return 'name' in value ? pathOmitter(value) : value;
};

var INTERNAL_KEY = '__internal__';
var RouterParametersController = {
  name: 'router-parameters-controller',
  props: {
    initial: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    from: {
      type: Function,
      default: same
    },
    to: {
      type: Function,
      default: same
    }
  },
  data: function data() {
    return {
      parameters: this.initial,
      hadChanged: false
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler: function handler(value, oldValue) {
        this.parameters = this.from(Object.assign( // eslint-disable-line prefer-object-spread
        {}, this.initial, value.params, value.query));
        var event = {
          parameters: this.parameters
        };
        this.$emit('change', event);

        if (value.params[INTERNAL_KEY]) {
          this.$emit('change:internal', event);
          return;
        }

        if (oldValue) {
          this.$emit('change:external', event);
        }

        if (!oldValue || !this.hadChanged) {
          this.$emit('change:initial', event);
          this.hadChanged = true;
        }
      }
    }
  },
  methods: {
    updateUrl: function updateUrl(parameters) {
      var parameterKeys = Object.keys(this.$route.params);
      var paramsPicker = pick(parameterKeys);
      var queryGetter = this.$route.name ? omit(parameterKeys) : same;
      var query = this.to(parameters);
      this.$router.push(routerOmitter(routerPicker(Object.assign( // eslint-disable-line prefer-object-spread
      {}, this.$route, {
        query: queryGetter(query),
        params: Object.assign( // eslint-disable-line prefer-object-spread
        {}, this.$route.params, paramsPicker(query), _defineProperty({}, INTERNAL_KEY, true))
      })))).catch(function () {}); // For the same URL vue-router throws here.
    },
    changeParameters: function changeParameters(value) {
      this.updateUrl(value);
    }
  },
  render: function render(h) {
    return renderSlim(this.$scopedSlots.default({
      parameters: this.parameters,
      changeParameters: this.changeParameters,
      updateUrl: this.updateUrl
    }), h, Tag);
  }
};

function install(Vue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? RouterParametersController.name : _ref$name;

  Vue.component(name, RouterParametersController);
}
var main = {
  install: install
};

export default main;
export { RouterParametersController };
